import React from 'react';

export const allowedDomainsForInvite = ['https://agents.strickbet.net', 'http://localhost:8003', 'http://localhost:8004'];

const useIfInviteHidden = () => {
  const isHidden = !allowedDomainsForInvite.includes(location.origin);

  return isHidden;
};

export default useIfInviteHidden;